import React, { useEffect, useState } from "react";
import renderSelectField from "../../shared/components/form/Select";
import { Field } from "redux-form";
import { connect } from "react-redux";
import { getRoles, resetRoles } from "./actions/roles.actions";
import { Alert, Spinner } from "reactstrap";
import { MdRefresh } from "react-icons/md";

const RolesSelect = (props) => {
    const { roles, label, dispatch, external, currentUser, id, required, domainCode, change, isUserRolesForm, userRoleName, userRoleId, onChange, isCreateUserForm } = props;
    const [data, setData] = useState([]);

    const userDomainCode = currentUser?.response?.domainCode;

    const fetchRoles = () => {
        if (isUserRolesForm || isCreateUserForm ) {
            dispatch(getRoles(domainCode));
        } else {
            dispatch(getRoles(userDomainCode));
        }
    };

    useEffect(() => {
        if(domainCode) {
            dispatch(getRoles(domainCode));
        } else {
            dispatch(getRoles(userDomainCode));
        }
    }, [dispatch, domainCode]);

    useEffect(() => {
        if (userRoleName && userRoleId) {
            dispatch(change("roles", { name: userRoleName, id: userRoleId }));
        }
        return () => dispatch(resetRoles());
    }, [dispatch, userRoleName, userRoleId ]);

    const rolesList = roles && roles.response ? roles.response.data : [];

    useEffect(() => {
        if(external) {
            const filteredRoles = rolesList.filter(role => role.name === "CORP_ADMIN");
            setData(filteredRoles)
            if(filteredRoles.length && change) {
               change("roles", { name: filteredRoles[0].name, id: filteredRoles[0].id});
            }
            
        }
    }, [roles.response, external]);
    
    return (
        <div className="form__form-group">
            <span className={`form__form-group-label ${required ? "required" : ""}`}>{label}</span>
            <div className="form__form-group-field">
                <Field id={id} name="roles" component={renderSelectField} options={external ? data : rolesList} valueKey="id" labelKey="name" onChange={isUserRolesForm ? onChange : null} />
            </div>
            {roles && roles.error ? (
                <Alert color="danger">
                    Could not fetch roles
                    {roles.loading ? <Spinner className="float-right" size="sm" color="danger" /> : <MdRefresh onClick={fetchRoles} className="float-right pointer" size={20} />}
                </Alert>
            ) : null}
        </div>
    );
};

export default connect((state) => ({
    roles: state.roles,
    permissions: state.permissions,
    currentUser: state.currentUser,
}))(RolesSelect);
